export default __webpack_public_path__ + "6e4400ae7cb38a5b0fab23e0ac98a04b.png";